<template>
  <layout>
    <div v-if="loaded && profileLoaded">
      <div
        v-if="
          loggedIn &&
            capabilities.baseline &&
            profileLoaded &&
            (isDocumentAdmin || canManageContentBlocks)
        "
      >
        <profile></profile>
        <separator></separator>
        <document-tools v-if="canManageContentBlocks"></document-tools>
        <separator v-if="canManageContentBlocks"></separator>
        <template-tools v-if="isDocumentAdmin"></template-tools>
        <separator v-if="isDocumentAdmin"></separator>
      </div>
      <danger v-if="!capabilities.baseline" title="Unsupported">
        Your version of sharedo does not support the Word add-in. Please contact
        our sales team to upgrade to the latest version.
      </danger>
      <danger
        v-if="
          loggedIn &&
            profileLoaded &&
            !(isDocumentAdmin || canManageContentBlocks)
        "
        title="Access Denied"
      >
        Please contact your system administrator as you have not been granted
        any rights to manage content.
      </danger>
    </div>
  </layout>
</template>
<script>
import { mapState } from "vuex";
import profileMixin from "@/mixins/profile";
import Danger from "@/components/common/banners/Danger.vue";
import Profile from "@/components/home/Profile.vue";
import DocumentTools from "@/components/home/DocumentTools.vue";
import TemplateTools from "@/components/home/TemplateTools.vue";
import profile from "@/services/sharedo/profileService";
import linkedTemplates from "@/services/word/linkedTemplatesService";
import shardeoDiscovery from "@/services/sharedo/sharedoDiscoveryService";
import sharedoCapabilities from "@/services/sharedo/sharedoCapabilitiesService";
import {
  ADMIN_DOCUMENT_ASSEMBLY,
  CONTENT_BLOCKS_READ,
} from "@/constants/permissions";

const initialize = async function() {
  if (!this.connected || !this.loggedIn) {
    this.logWarning("User is not logged in.", {
      connected: this.connected,
      loggedIn: this.loggedIn,
    });
    
    this.$router.push("/landing");
  }

  if (this.connected) {
    const capabilities = await shardeoDiscovery.getCapabilities();
    sharedoCapabilities.set(capabilities);
    this.logInfo("Retrieved sharedo capabilies.", { capabilities });
  }

  if (this.connected && this.loggedIn) {
    const userProfile = await profile.get();
    this.fullName = userProfile.fullName;

    const templates = await linkedTemplates.get();
    this.$store.commit("currentTemplates", { templates });
    this.logInfo("Set linked templates.", { templates });
  }

  this.loaded = true;
};

export default {
  components: { Danger, Profile, DocumentTools, TemplateTools },
  mixins: [profileMixin],
  data: function() {
    return {
      loaded: false,
    };
  },
  mounted: initialize,
  computed: {
    ...mapState({
      loggedIn: (state) => state.loggedIn,
      connected: (state) => state.connected,
    }),
    isDocumentAdmin: function() {
      return this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY);
    },
    canManageContentBlocks: function() {
      if (this.capabilities.contentBlockPermissionsV2) {
        return (
          this.hasPermission(CONTENT_BLOCKS_READ) ||
          this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY)
        );
      }

      return this.hasPermission(CONTENT_BLOCKS_READ);
    },
  },
};
</script>
